{
  "order_button": "Order via WhatsApp",
  "order_button_short": "WhatsApp",
  "support_button": "WhatsApp Help",
  "confirmation": {
    "title": "Confirm via WhatsApp",
    "subtitle": "Send your order directly on WhatsApp for quick confirmation",
    "send": "Send on WhatsApp",
    "already_confirmed": "I already confirmed",
    "preview_title": "Message preview"
  },
  "messages": {
    "order_greeting": "Hello, I would like to order:",
    "order_total": "Total",
    "order_delivery": "Delivery",
    "order_payment": "Payment",
    "order_thanks": "Thank you!",
    "support_greeting": "Hello, I need help with",
    "tracking_request": "Hello, I would like to track my order"
  },
  "new_order_title": "New Djayma order"
}
